import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { eventTypes } from '@/mocks/artists';

export default function EventTypesSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-gray-900">
      <div className="flex items-start justify-between gap-4 mb-10 md:mb-14">
        <span className="inline-flex items-center px-4 py-1.5 text-xs font-medium text-white border border-white/30 rounded-full">
          {t('eventTypes.label')}
        </span>
      </div>

      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-2xl mb-10 md:mb-16">
        {t('eventTypes.title')}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {eventTypes.slice(0, 4).map((event) => (
          <Link
            key={event.id}
            to={`/artistas?evento=${event.slug}`}
            className="group block"
          >
            <div className="relative aspect-square rounded-2xl md:rounded-3xl overflow-hidden bg-amber-50">
              <img
                src={event.imageUrl}
                alt={event.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div className="mt-3 md:mt-4">
              <h3 className="text-base md:text-lg font-semibold text-white group-hover:text-amber-400 transition-colors">
                {event.name}
              </h3>
              <p className="text-xs md:text-sm text-gray-400 mt-1">{event.description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-4 md:mt-6">
        {eventTypes.slice(4, 7).map((event) => (
          <Link
            key={event.id}
            to={`/artistas?evento=${event.slug}`}
            className="group block"
          >
            <div className="relative aspect-[16/10] rounded-2xl md:rounded-3xl overflow-hidden bg-amber-50">
              <img
                src={event.imageUrl}
                alt={event.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div className="mt-3 md:mt-4">
              <h3 className="text-base md:text-lg font-semibold text-white group-hover:text-amber-400 transition-colors">
                {event.name}
              </h3>
              <p className="text-xs md:text-sm text-gray-400 mt-1">{event.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}